import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { sessionTenant } from "../services/sessions";
import { DEFAULT_POLICY, watchSessionPolicy } from "../services/sessionPolicy";

/** Live session policy of the signed-in user's company, plus its tenant id. */
export default function useSessionPolicy() {
  const { user, userProfile } = useAuth();
  const tenantId = user?.uid && userProfile ? sessionTenant(userProfile, user.uid) : null;
  const [policy, setPolicy] = useState(DEFAULT_POLICY);

  useEffect(() => watchSessionPolicy(tenantId, setPolicy), [tenantId]);

  return { tenantId, policy };
}
